import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { MessageCircle, User, Heart, Sparkles } from "lucide-react";
import { useNotifications } from "@/contexts/NotificationContext";

// Custom Matches icon - sparkles with heart
const MatchesIcon = ({ active }) => (
  <div className={`relative w-7 h-7 ${active ? "text-[#FAB710]" : "text-white/60"}`}>
    <Sparkles className="w-7 h-7" fill={active ? "#FAB710" : "none"} />
  </div>
);

// Badge component for notification counts
const NotificationBadge = ({ count }) => {
  if (!count || count <= 0) return null;
  
  return (
    <span 
      className="absolute -top-1 -right-1 min-w-[18px] h-[18px] bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center px-1"
      data-testid="notification-badge"
    >
      {count > 99 ? "99+" : count}
    </span>
  );
};

const BottomNav = () => {
  const location = useLocation();
  const { unreadMessages, newMatches } = useNotifications();
  
  const navItems = [
    { path: "/matches", icon: "matches", label: "Matches", badge: newMatches },
    { path: "/messages", icon: MessageCircle, label: "Messages", badge: unreadMessages },
    { path: "/likes", icon: Heart, label: "Likes", badge: 0 },
    { path: "/profile", icon: User, label: "Profile", badge: 0 }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-[#1C3A7A] px-4 py-2 z-50 lg:hidden">
      <div className="flex items-center justify-around max-w-md mx-auto">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`relative flex flex-col items-center py-2 px-4 rounded-xl transition-colors ${
                isActive
                  ? "text-[#FAB710]"
                  : "text-white/60 hover:text-white"
              }`}
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              <div className="relative">
                {item.icon === "matches" ? (
                  <MatchesIcon active={isActive} />
                ) : (
                  <Icon className={`w-6 h-6 ${isActive ? "text-[#FAB710]" : ""}`} />
                )}
                <NotificationBadge count={item.badge} />
              </div>
              <span className="text-xs mt-1 font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
